import React from 'react';
import {Link} from "react-router-dom";

const SidebarBanner = () => {
    return (
        <div className="sidebar-widget-content">
            <div className="sidebar-widget-banner overlay-two" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/spray.webp)`}} >
                <h3 className="title">About Us</h3>
                <p>The premier insulation company for Northern Virginia, Washington DC, and Maryland.</p>
                <Link to={process.env.PUBLIC_URL + "/about"}>Learn About Our Team</Link>
            </div>
        </div>
    )
}

export default SidebarBanner;
